<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
    <router-link to="/logout">Logout</router-link>
  </nav> -->
  <component :is="this.$route.meta.layout || 'div'">
        <b-container
          :toast="{root: true}"
          fluid="sm" position="position-fixed"
          ></b-container>
           <router-view></router-view>
           
        </component>
  
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding:5px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>